import React, { useState } from 'react'
import { alsokTheme } from '../styles/alsok-theme'

const VisitorRegistration = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    visitorName: '',
    company: '',
    contactPerson: '',
    department: '',
    purpose: '',
    phone: '',
    email: '',
    visitDuration: '30',
    notes: ''
  })
  
  const [isSubmitting, setIsSubmitting] = useState(false)
  
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    
    try {
      // 来客登録処理（モック）
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      const registrationData = {
        ...formData,
        timestamp: new Date(),
        id: `VISITOR_${Date.now()}`,
        status: 'checked_in'
      }
      
      onSubmit(registrationData)
      onClose()
      
      // フォームリセット
      setFormData({
        visitorName: '',
        company: '',
        contactPerson: '',
        department: '',
        purpose: '',
        phone: '',
        email: '',
        visitDuration: '30',
        notes: ''
      })
      
    } catch (error) {
      console.error('来客登録エラー:', error)
    } finally {
      setIsSubmitting(false)
    }
  }
  
  if (!isOpen) return null
  
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>📋 来客登録</h2>
          <button 
            className="close-btn"
            onClick={onClose}
            disabled={isSubmitting}
          >
            ✕
          </button>
        </div>
        
        <form className="registration-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>👤 来訪者情報</h3>
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="visitorName">お名前 *</label>
                <input
                  type="text"
                  id="visitorName"
                  name="visitorName"
                  value={formData.visitorName}
                  onChange={handleChange}
                  required
                  placeholder="田中太郎"
                />
              </div>
              <div className="form-field">
                <label htmlFor="company">会社名・団体名 *</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  placeholder="○○株式会社"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="phone">電話番号</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="03-1234-5678"
                />
              </div>
              <div className="form-field">
                <label htmlFor="email">メールアドレス</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="example@company.com"
                />
              </div>
            </div>
          </div>
          
          <div className="form-section">
            <h3>🏢 面会情報</h3>
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="contactPerson">面会者名 *</label>
                <input
                  type="text"
                  id="contactPerson"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  required
                  placeholder="鈴木次郎"
                />
              </div>
              <div className="form-field">
                <label htmlFor="department">所属部署</label>
                <input
                  type="text"
                  id="department"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  placeholder="営業部"
                />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-field">
                <label htmlFor="purpose">来訪目的 *</label>
                <select
                  id="purpose"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleChange}
                  required
                >
                  <option value="">選択してください</option>
                  <option value="meeting">会議・打ち合わせ</option>
                  <option value="business">営業・商談</option>
                  <option value="interview">面接</option>
                  <option value="maintenance">保守・メンテナンス</option>
                  <option value="delivery">配送・集荷</option>
                  <option value="other">その他</option>
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="visitDuration">滞在予定時間</label>
                <select
                  id="visitDuration"
                  name="visitDuration"
                  value={formData.visitDuration}
                  onChange={handleChange}
                >
                  <option value="15">15分</option>
                  <option value="30">30分</option>
                  <option value="60">1時間</option>
                  <option value="120">2時間</option>
                  <option value="240">半日</option>
                  <option value="480">終日</option>
                </select>
              </div>
            </div>
          </div>
          
          <div className="form-section">
            <div className="form-field">
              <label htmlFor="notes">備考</label>
              <textarea
                id="notes"
                name="notes"
                value={formData.notes}
                onChange={handleChange}
                rows="3"
                placeholder="特記事項がございましたらご記入ください"
              />
            </div>
          </div>
          
          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={onClose}
              disabled={isSubmitting}
            >
              キャンセル
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? '登録中...' : '来客登録'}
            </button>
          </div>
        </form>
      </div>
      
      <style jsx="true">{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }
        
        .modal-content {
          background: white;
          border-radius: ${alsokTheme.borderRadius.lg};
          width: 90%;
          max-width: 600px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: ${alsokTheme.shadows.xl};
          border: 3px solid ${alsokTheme.primary.light};
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 25px;
          background: ${alsokTheme.gradients.security};
          color: white;
          border-radius: ${alsokTheme.borderRadius.lg} ${alsokTheme.borderRadius.lg} 0 0;
        }
        
        .modal-header h2 {
          margin: 0;
          font-size: 20px;
          font-weight: bold;
        }
        
        .close-btn {
          background: none;
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          transition: background 0.3s ease;
        }
        
        .close-btn:hover {
          background: rgba(255, 255, 255, 0.2);
        }
        
        .registration-form {
          padding: 25px;
        }
        
        .form-section {
          margin-bottom: 25px;
        }
        
        .form-section h3 {
          margin: 0 0 15px 0;
          color: ${alsokTheme.primary.main};
          font-size: 16px;
          font-weight: bold;
          border-bottom: 2px solid ${alsokTheme.primary.light};
          padding-bottom: 5px;
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 15px;
        }
        
        .form-field {
          display: flex;
          flex-direction: column;
        }
        
        .form-field label {
          margin-bottom: 5px;
          font-weight: bold;
          color: ${alsokTheme.neutral.darkGray};
          font-size: 14px;
        }
        
        .form-field input,
        .form-field select,
        .form-field textarea {
          padding: 10px 12px;
          border: 2px solid ${alsokTheme.neutral.lightGray};
          border-radius: ${alsokTheme.borderRadius.md};
          font-size: 14px;
          transition: border-color 0.3s ease;
        }
        
        .form-field input:focus,
        .form-field select:focus,
        .form-field textarea:focus {
          outline: none;
          border-color: ${alsokTheme.primary.main};
          box-shadow: 0 0 0 3px rgba(0, 51, 102, 0.1);
        }
        
        .form-field input:required {
          border-left: 4px solid ${alsokTheme.status.warning};
        }
        
        .form-field textarea {
          resize: vertical;
          min-height: 80px;
        }
        
        .form-actions {
          display: flex;
          justify-content: flex-end;
          gap: 15px;
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid ${alsokTheme.neutral.lightGray};
        }
        
        .cancel-btn,
        .submit-btn {
          padding: 12px 24px;
          border: none;
          border-radius: ${alsokTheme.borderRadius.md};
          font-size: 14px;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          min-width: 120px;
        }
        
        .cancel-btn {
          background: ${alsokTheme.neutral.mediumGray};
          color: white;
        }
        
        .cancel-btn:hover {
          background: ${alsokTheme.neutral.darkGray};
          transform: translateY(-1px);
        }
        
        .submit-btn {
          background: ${alsokTheme.gradients.security};
          color: white;
        }
        
        .submit-btn:hover {
          transform: translateY(-1px);
          box-shadow: ${alsokTheme.shadows.lg};
        }
        
        .submit-btn:disabled,
        .cancel-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }
        
        @media (max-width: 768px) {
          .modal-content {
            width: 95%;
            margin: 10px;
          }
          
          .form-row {
            grid-template-columns: 1fr;
            gap: 10px;
          }
          
          .modal-header {
            padding: 15px 20px;
          }
          
          .registration-form {
            padding: 20px;
          }
          
          .form-actions {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  )
}

export default VisitorRegistration